import { getFormattedPrice } from '@/components/elements/Card/ServiceListCard/ServiceListCard.helper';
import { capitalizeFirstLetter } from '@/helpers/strings';
import useMobileView from '@/hooks/useMobileView';
import { SelectServiceItem } from '../views/SelectService.types';

/** The "Om tjänsten" content card, shared by ServiceItem's info sheet and the drawer's overlay. */
const LegacyServiceInfoCard = ({ service }: { service: SelectServiceItem }) => {
  const { isMobileView } = useMobileView();

  return (
    <div className="bg-surface_l2 p-md gap-sm drop-shadow-xs flex flex-col rounded-lg">
      <span className="text-fg_primary text-xl font-bold">{capitalizeFirstLetter(service.name)}</span>
      {(service.duration || service.price) && (
        <div className="gap-sm flex items-baseline">
          {service.duration && <span className="text-l text-fg_primary font-bold">{service.duration}</span>}
          {service.price && (
            <span className="text-l text-fg_secondary">
              {getFormattedPrice({
                value: service.price.value,
                type: service.price.type,
                isMobileView,
                hasDiscounts: false,
                hidePriceLabel: true,
              })}
            </span>
          )}
        </div>
      )}
      {service.description && (
        <>
          <div className="border-border_regular border-b" aria-hidden="true" />
          <p className="text-m text-fg_secondary">{service.description}</p>
        </>
      )}
    </div>
  );
};

export default LegacyServiceInfoCard;
